import { SubAPI } from "./SubAPI";
export class ApiTokens extends SubAPI {
    list(input) { return this.fetcher.get("/api/api-tokens", input); }
    create(input) { return this.fetcher.post("/api/api-token", input); }
    revoke(input) { return this.fetcher.post("/api/api-token", input); }
}
